import Model from '@/core/models/Model';

export default class TrainingQualification extends Model {
  resource() {
    return 'worker/qualifications';
  }
}
